import { Modal, ModalSizes } from 'plataforma-fundacao-componentes';
import { languageValues } from 'helpers/utils/languageUtils';

import { ModalProps } from 'plataforma-fundacao-componentes/dist/components/modal/Modal';

export const UnanticipatedUser = (props: ModalProps) => {
  return (
    <Modal
      title={languageValues.modals.emancipedUser.title}
      preventEscExit={props.preventEscExit || false}
      preventMaskExit={props.preventMaskExit || false}
      modalKey={props.modalKey}
      mobileOn={props.mobileOn}
      onClose={props.onClose}
      size={ModalSizes.ExtraLarge}
    >
      <p className={'nunito'}>
        {languageValues.modals.emancipedUser.description1}
        <br></br>
        <br></br>
        {languageValues.modals.emancipedUser.description2}
        <br></br>
        <br></br>
        {languageValues.modals.emancipedUser.description3}
      </p>
    </Modal>
  );
};
